import { render, staticRenderFns } from "./AIAssitant.vue?vue&type=template&id=da9e2708&scoped=true&"
import script from "./AIAssitant.vue?vue&type=script&lang=js&"
export * from "./AIAssitant.vue?vue&type=script&lang=js&"
import style0 from "./AIAssitant.vue?vue&type=style&index=0&id=da9e2708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9e2708",
  null
  
)

export default component.exports